import { useEffect, useState, useCallback } from "react";
import { api } from "../../lib/api";
import { Card, CardHead } from "../../components/common";
import { useFileMeta, ProcessSheet } from "../../components/FileCenter";
import { ProcessTable } from "./BoFiles";

const STAGES = [["entrada", "Entrada do cliente", ["recebido", "aguardando_conferencia", "em_conferencia", "com_pendencia", "aguardando_cliente", "validado"]],
  ["processamento", "Processamento", ["preparando_alterdata", "pronto_alterdata", "enviado_alterdata", "em_processamento", "processado"]],
  ["saida", "Saída Alterdata", ["resultado_recebido", "conferencia_final"]], ["entrega", "Entrega ao cliente", ["disponivel_cliente", "concluido", "cancelado"]]];

export function ClientFiles({ companyId }) {
  const meta = useFileMeta();
  const [rows, setRows] = useState([]);
  const [tab, setTab] = useState("entrada");
  const [open, setOpen] = useState(null);
  const load = useCallback(() => api.get("/file-center/processes", { params: { company_id: companyId } }).then((r) => setRows(r.data)), [companyId]);
  useEffect(() => { load(); }, [load]);
  if (!meta) return null;
  const cur = STAGES.find((s) => s[0] === tab);
  return (
    <Card testid="client-files">
      <CardHead title="Arquivos / Integrações" hint="Somente arquivos desta empresa" right={<div className="flex flex-wrap gap-1">{STAGES.map(([k, l, st]) => <button key={k} data-testid={`client-files-tab-${k}`} onClick={() => setTab(k)} className={`text-xs px-2.5 py-1 rounded-full border ${tab === k ? "bg-slate-900 text-white" : "bg-white"}`}>{l} ({rows.filter((r) => st.includes(r.status)).length})</button>)}</div>} />
      <div className="overflow-x-auto"><ProcessTable rows={rows.filter((r) => cur[2].includes(r.status))} meta={meta} onOpen={setOpen} showCompany={false} onChanged={load} /></div>
      <ProcessSheet id={open} open={!!open} internal onOpenChange={(o) => !o && setOpen(null)} onChanged={load} />
    </Card>
  );
}
